/*
by zhou 2016/10/19
 */
"use strict";
angular.module('newWindowReleaseComponentManageModule', [])
    .controller('newWindowReleaseComponentManageCtrl', ['$scope', "$modalInstance", "Params",
        function($scope, $modalInstance, Params) {
            initStatus();
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.status.windows = Params;
                $scope.title = Params.ObjectId == 0? "新建组件" :"修改组件";
            }
            /**
             * [cancel description:取消]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
            /**
             * [confirm description:确定]
             */
            $scope.confirm = function() {
                $modalInstance.close($scope.status.windows);
            };
        }
    ]);
